import React from "react";
import { DownloadOutlined } from "@ant-design/icons";
import { message } from "antd";
import { isEmpty } from "lodash";
import { useUserInfo } from "./store";
import { Button } from "react-bootstrap";
import { isDownloadDisabled } from "modules/utilities/utility";
import { convertTo12HourFormat } from "helpers/utils";

const DownloadCSV = () => {
  const { userData } = useUserInfo();
  const users = userData;
  const exportCSV = () => {
    try {
      let csvRow = [];
      let rowName = [
        [
          encodeURIComponent("UserID"),
          encodeURIComponent("FirstName"),
          encodeURIComponent("Email"), // Only one occurrence of "Email"
          encodeURIComponent("PhoneNumber"),
          encodeURIComponent("Role"),
          encodeURIComponent("Gender"),
          encodeURIComponent("IsActive"),
          encodeURIComponent("level"),
          encodeURIComponent("deactivated"),
          encodeURIComponent("doctor_type"),
          encodeURIComponent("BreakWeekDays"),
          encodeURIComponent("AlternateEmail"),
          encodeURIComponent("Tip"),
          encodeURIComponent("Description"),
          encodeURIComponent("Level"),
          encodeURIComponent("RoleId"),
          encodeURIComponent("IsConsultDoctor"),
          encodeURIComponent("IsConsultDoctorActive"),
          encodeURIComponent("CallHippo"),
          encodeURIComponent("LimeChatUserId"),
          encodeURIComponent("canDoFemalePrescription"),
          encodeURIComponent("breakTimings")
        ],
      ];

      for (let item = 0; item < users?.length; item++) {
        const user = users[item].user;

        const firstName = `"${user.first_name.replace(/ /g, "_")}"`;
        const doctorType = user.doctorType?.[0]?.type || "N/A";
        const breakWeekDays = `"${user.meta?.breakWeekDays?.join(',')}"`;
        const roleName = `"${users[item].role.name || "N/A"}"`;
        const phoneNumber = `"${user.phone_number || "N/A"}"`;
        const email = `"${user.email || "N/A"}"`;
        const gender = `"${user.gender || "N/A"}"`;
        const isActive = `"${user.is_active ? "Yes" : "No"}"`;
        const level = `"${user.level || "N/A"}"`;
        const deactivated = `"${user.deactivated ? "Yes" : "No"}"`;
        const alternateEmail = `"${user.alternate_email || "N/A"}"`;
        const tip = `"${user.tip || "N/A"}"`;
        const description = `"${user.description || "N/A"}"`;
        const roleId = `"${users[item].role.id || "N/A"}"`;
        const isConsultDoctor = `"${user.is_consult_doctor || "N/A"}"`;
        const isConsultDoctorActive = `"${user.is_consult_doctor_active || "N/A"}"`;
        const callHippo = `"${user.meta?.call_hippo || "false"}"`;
        const limeChatUserId = `"${user.meta?.limechat_user_id || "N/A"}"`;
        const canDoFemalePrescription = `"${user.can_do_female_presc ? "Yes" : "No"}"`;

        let breakTimings = user.meta?.shifts && Array.isArray(user.meta?.shifts)
          ? user.meta?.shifts
            .map(shift => {
              // Validate if both startTime and endTime are strings and not empty
              if (shift?.startTime && shift?.endTime && typeof shift.startTime === 'string' && typeof shift.endTime === 'string') {
                return `${convertTo12HourFormat(shift.startTime)}-${convertTo12HourFormat(shift.endTime)}`;
              };
              return null;
            })
            .filter(Boolean)
            .join("_and_")
          : "No_Break_Timings";

        if (isEmpty(breakTimings)) {
          breakTimings = `"No_Break_Timings"`;
        } else {
          breakTimings = `"${breakTimings}"`
        };

        rowName.push([
          encodeURIComponent(users[item].user.id),
          firstName,
          email,
          phoneNumber,
          roleName,
          gender,
          isActive,
          level,
          deactivated,
          doctorType,
          breakWeekDays,
          alternateEmail,
          tip,
          description,
          level,
          roleId,
          isConsultDoctor,
          isConsultDoctorActive,
          callHippo,
          limeChatUserId,
          canDoFemalePrescription,
          breakTimings
        ]);
      }

      rowName.forEach((row) => {
        csvRow.push(row.join(","));
      });

      let csvString = csvRow.join("%0A");
      let anchorTag = document.createElement("a");
      anchorTag.href = "data:attachment/csv," + csvString;
      anchorTag.target = "_Blank";
      anchorTag.download = "user_data.csv";
      document.body.appendChild(anchorTag);
      anchorTag.click();
    } catch (error) {
      message.error("Download error");
    }
  };

  return (
    <Button
      type="primary"
      icon={<DownloadOutlined />}
      onClick={exportCSV}
      className="me-2"
      disabled={isDownloadDisabled && isEmpty(users)}
    >
      Download Users
    </Button>
  );
};

export default DownloadCSV;
